"use client";

import Link from "next/link";
import { useParams, usePathname, useSearchParams } from "next/navigation";

export const YearPathLink = ({ targetYear, children }: { targetYear: string; children: React.ReactNode }) => {
  const params = useParams();
  const { year, date } = params;
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const searchParamsObj = new URLSearchParams(searchParams.toString());
  const path = pathName.replace(Array.isArray(year) ? (year[0] as string) : (year as string), targetYear);

  const href = date ? pathName : `${path}?${searchParamsObj.toString()}`;
  return (
    <li className={`${targetYear === year ? "text-primary" : "hover:link-secondary"} link badge badge-neutral`}>
      <Link href={href} scroll={false}>
        {children}
      </Link>
    </li>
  );
};
